import React from 'react';

export const LABEL_MODES = {
  create: 'create',
  edit: 'edit',
};

export const LABEL_BUTTON_CLASS = {
  create: 'create-label-button',
  edit: 'edit-label-button',
  delete: 'delete-label-button',
  menu: 'popover-action',
  toggleLabelVisibility: 'toggle-label-visibility',
  moveup: 'move-up-button',
  movedown: 'move-down-button',
};

export const LEFT_POPOVER_MENU_NAME = {
  create: 'New Label',
  edit: 'Edit',
  delete: 'Delete Label',
};

export const TEACHER_ORGANIZE_EXAMPLE_MODAL = {
  title: 'Labels',
  ...LEFT_POPOVER_MENU_NAME,
};

export const DELETE_CONFIRMATION_DEFAULT = (
  <React.Fragment>
    Are you sure you want to delete this label? This will also delete all labels
    nested under this one, and will remove this label from all resources.
    <br />
    <br />
    This action cannot be undone.
  </React.Fragment>
);

export const resourceTypes = {
  item: 'item',
  video: 'video',
  pdf: 'pdf',
};

export const resourcesForBulkInitState = {
  [resourceTypes.item]: {},
  [resourceTypes.video]: {},
  [resourceTypes.pdf]: {},
};
